import { ORIGIN_SOURCE_GROUP_ITEMS } from 'src/modules/global-vars';
import { tr } from 'src/modules/i18n-helpers';
import { ORIGIN_SOURCE_GROUPS } from 'src/modules/labels';

import FilterAutocompleteGroupSelect from './FilterAutocompleteGroupSelect';

type OriginSourceGroupsFilterProps = {
  elements: string[];
  groups: string[];
  name: string;
  label?: string;
  isLoading?: boolean;
  historicOptions?: string[];
};

const OriginSourceGroupsFilter = ({
  elements,
  groups,
  name,
  label,
  isLoading,
  historicOptions = [],
}: OriginSourceGroupsFilterProps) => {
  const options = ORIGIN_SOURCE_GROUP_ITEMS.filter(
    (source) => elements.includes(source.value) || groups.includes(source.group),
  );
  const availableGroups = Array.from(new Set(options.map((option) => option.group)));
  const groupOptions = ORIGIN_SOURCE_GROUPS.filter((group) => availableGroups.includes(group.value));

  const nonAvailable = options.filter((item) => !elements.includes(item.value)).map((item) => item.value);
  const historicOrNotAvailable = [...historicOptions, ...nonAvailable];

  return (
    <FilterAutocompleteGroupSelect
      name={name}
      groups={groupOptions}
      options={options}
      label={tr(label || '')}
      isLoading={isLoading}
      historicOptions={historicOrNotAvailable}
    />
  );
};

export default OriginSourceGroupsFilter;
